import { useEffect } from "react";

/**
 * Título da aba por rota.
 *
 * O `head()` por rota era API do TanStack Start e saiu na conversão para SPA.
 * Como a operação trabalha com várias abas abertas ao mesmo tempo, resolver o
 * título num único lugar é mais barato do que um hook por tela.
 */
const TITULOS: Record<string, string> = {
  "/login": "Entrar",
  "/loja": "Flow — Grade de alocação",
  "/pipeline": "Pipeline",
  "/dashboard": "Dashboard",
  "/solicitacoes": "Solicitações",
  "/notificacoes": "Notificações",
  "/parametrizacao": "Parametrização",
  "/perfis": "Perfis e permissões",
  "/fit": "Fit de Alocação",
  "/admin-ia": "Alimentação da IA",
};

const BASE = "SOAP Flow";

export function tituloDaRota(pathname: string): string {
  if (pathname.startsWith("/card/")) return `Card · ${BASE}`;
  const titulo = TITULOS[pathname];
  return titulo ? `${titulo} · ${BASE}` : BASE;
}

export function useTituloPagina(pathname: string) {
  useEffect(() => {
    document.title = tituloDaRota(pathname);
  }, [pathname]);
}
